export const updateTraining = ({ form, user }) => {

    console.log(user);

    form.setValues({
        "CRM[Completed]": user.CRM?.Completed,
        "CRM[Date]": user.CRM?.Date,
        "LFTE[Completed]": user.LFTE?.Completed,
        "LFTE[Date]": user.LFTE?.Date,
    });

    form.setConfig({
        "title": "Update Information",
        "type": "update",
        "location": `FlightTestCrew/${user.ID}`,
        "fields": [{
            "label": "CRM Training",
            "type": "sectionHeader",
            "divClass": "md:col-span-3 border-t border-t-1",
        }, {
            "label": "CRM Training Completed",
            "name": "CRM[Completed]",
            "type": "dropdown",
            "dropdownData": [{
                "label": "Yes",
                "id": true
            }, {
                "label": "No",
                "id": false
            }]
        }, {
            "label": "CRM Training Completed Date",
            "name": "CRM[Date]",
            "type": "date",
            "required": false
        }, {
            "label": "LFTE Training",
            "type": "sectionHeader",
            "divClass": "md:col-span-3 border-t border-t-1",
        }, {
            "label": "LFTE Training Completed",
            "name": "LFTE[Completed]",
            "type": "dropdown",
            "dropdownData": [{
                "label": "Yes",
                "id": true
            }, {
                "label": "No",
                "id": false
            }]
        }, {
            "label": "LFTE Training Completed Date",
            "name": "LFTE[Date]",
            "type": "date",
            "required": false
        }]
    });

    form.getDropdownData();
    
    form.toggle();
};


export const updateRoleExperience = ({ form, user }) => {
    
        form.setValues({
            "RoleExperience": user.RoleExperience,
        });
    
        form.setConfig({
            "title": "Update Information",
            "type": "update",
            "location": `FlightTestCrew/${user.ID}`,
            "fields": [{
                "label": "Role Experience",
                "name": "RoleExperience",
                "type": "richtext",
                "divClass": "md:col-span-3 border-t border-t-1",
                "required": false
            }]
        });
    
        form.toggle();
    };
